import { render, staticRenderFns } from "./transformation-items-card.vue?vue&type=template&id=a6f74970&scoped=true"
import script from "./transformation-items-card.vue?vue&type=script&lang=js"
export * from "./transformation-items-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f74970",
  null
  
)

export default component.exports